// Lot 737 — feu vert / orange / rouge en tête de Supervision : « Yalola va bien · À surveiller · Problème », calculé
// par le serveur sur les SEULS incidents vus par les membres (plantages au 1er plan + ANR, coupures confirmées) et par
// le serveur (pannes, redémarrages inattendus) sur 24 h. Le bruit Android (mémoire en arrière-plan) et les coupures
// réseau groupées (serveur sain) n'y entrent pas.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const COLORS = { green: "#1B7A3D", orange: "#B45309", red: "#B42318" };
const BG = { green: "#E8F5EC", orange: "#FFF4E5", red: "#FDECEA" };

export const HealthLightCard = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get("/admin/health/traffic-light").then(({ data }) => { if (alive) { if (data?.level && COLORS[data.level]) setD(data); else setErr(true); } }).catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, []);
  if (err) return null;
  const level = d?.level || "green";
  const color = COLORS[level];
  return (
    <div className="rounded-2xl p-4 flex items-start gap-3" style={{ background: d ? BG[level] : "var(--yalola-bg)", border: `1px solid ${d ? color + "55" : "var(--yalola-border)"}` }} data-testid="health-light" data-level={d ? level : "loading"}>
      <span className="mt-1 h-4 w-4 rounded-full shrink-0" style={{ background: d ? color : "var(--yalola-border)", boxShadow: d ? `0 0 0 4px ${color}22` : "none" }} data-testid="health-light-dot" />
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className="text-base md:text-lg font-black" style={{ color: d ? color : "var(--yalola-text-muted)" }} data-testid="health-light-label">{d ? d.label : "Vérification…"}</span>
          {d && <span className="text-[11px]" style={{ color: "var(--yalola-text-muted)" }}>dernières {d.hours} h · membres + serveur uniquement</span>}
        </div>
        {d && (
          <ul className="text-[12px] mt-1 space-y-0.5" data-testid="health-light-reasons">
            {(d.reasons || []).map((r) => <li key={r}>• {r}</li>)}
          </ul>
        )}
        <div className="text-[11px] mt-1.5" style={{ color: "var(--yalola-text-muted)" }}>
          Vert = aucune coupure confirmée, aucun redémarrage inattendu, plantages vus par moins de 3 appareils (et &lt; 1 % des actifs) · Orange = 1 redémarrage inattendu ou plantages sur ≥ 3 appareils · Rouge = coupure de plateforme confirmée, panne serveur en cours, ≥ 2 redémarrages inattendus ou plantages sur ≥ 5 % des appareils actifs. Mémoire en arrière-plan, coupures réseau groupées et signalements isolés ne comptent pas.
        </div>
      </div>
    </div>
  );
};
